var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["facets/category-sort.j2"] = require( "facets/category-sort.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-sort-by-outer-mobile.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-row dom-sort-by-mobile\">\n    <div class=\"o-column o-extra-small--12 c-category-sort-by__outer\">\n        <h3 class=\"c-category-sort-by__h3\" data-qa-sort-by-label>";
output += runtime.suppressValue((lineno = 2, colno = 67, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_facets-sort-label"])), env.opts.autoescape);
output += "</h3>\n        \n        <ul data-facet-name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sort"), env.opts.autoescape);
output += "\" class=\"c-category-sort-by__ul\" data-qa-facet-name=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "sort"), env.opts.autoescape);
output += "\">";
env.getTemplate("facets/category-sort.j2", false, "category/templates/facets/category-sort-by-outer-mobile.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "</ul>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-sort-by-outer-mobile.j2"] , dependencies)